import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { VendingItem } from "./VendingItem";

export class Coin extends Phaser.GameObjects.Sprite {
    id: number;
    value: number;
    startPosition: Phaser.Geom.Point;
    inMachine: boolean;
    spent: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, id: number) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "g");

        this.id = id;
        this.value = ob.properties["value"] as number;

        this.inMachine = false;
        this.spent = false;

        this.setDepth(3);

        this.startPosition = new Phaser.Geom.Point(this.x, this.y);

        this.setInteractive();
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }

    putBackInPile() {
        this.x = this.startPosition.x;
        this.y = this.startPosition.y;

        this.inMachine = false;
        this.setScale(1);
    }
}



// WEBPACK FOOTER //
// ./src/games/VendingMachine/objects/Coin.ts